import { UseQueryOptions } from 'react-query';
import { Prospect } from '../../../types/api/endpoints/prospect/prospect.types';
import { PageQueryParams } from '../../../types/api/api.types';

export type UseProspectsOptions = Omit<UseQueryOptions<any, any, any, any>, 'queryKey' | 'queryFn'>;

export interface UseProspectsQueryParams extends PageQueryParams {
  filter?: UseProspectsFilters;
}

export interface UseProspectsResponse {
  total: number;
  results: Prospect[];
}

export enum UseProspectsFilters {
  Contacter = 'à contacter',
  Relancer = 'à relancer',
  ShowAll = 'afficher tout'
}